import type { IJsonQuery } from 'shared/json_query';

export function getRailwayAndHighwayPuids(jsonQuery: IJsonQuery): { [key: string]: string } {
  return jsonQuery.geo && jsonQuery.geo.value
    ? jsonQuery.geo.value.reduce(
        (acc, next) => {
          if (next.type === 'railway' && jsonQuery._type.includes('suburban')) {
            acc.puid34 = acc.puid34 ? `${acc.puid34}:${next.id}` : String(next.id);
          }

          if (next.type === 'highway' && jsonQuery._type.includes('suburban')) {
            acc.puid35 = acc.puid35 ? `${acc.puid35}:${next.id}` : String(next.id);
          }

          return acc;
        },
        { puid34: '', puid35: '' },
      )
    : {};
}
